##
# To learn more about HTML Serializer check out the Prismic documentation
# https://prismic.io/docs/vuejs/beyond-the-api/html-serializer
##

import prismicDOM from 'prismic-dom'
import linkResolver from './link-resolver.coffee'

Elements = prismicDOM.RichText.Elements

export default (type, element, content, children) -> 
    # Generate links to Prismic Documents as <router-link> components
    # Present by default, it is recommended to keep this
    if type is Elements.hyperlink 
        result = ''
        url = prismicDOM.Link.url element.data, linkResolver

        if element.data.link_type is 'Document' 
            result = """<router-link to="#{url}">#{content}</router-link>"""
        else 
            target = if element.data.target then 'target="#{element.data.target}" rel="noopener"' else ''
            result = """<a href="#{url}" #{target}>#{content}</a>"""
        
        return result
    

    # If the image is also a link to a Prismic Document, it will return a <router-link> component
    # Present by default, it is recommended to keep this
    if type is Elements.image
        result = """<img src="#{element.url}" alt="#{element.alt || ""}" copyright="#{element.copyright || ""}">"""

        if element.linkTo
            url = prismicDOM.Link.url element.linkTo, linkResolver

            if element.linkTo.link_type is 'Document' 
                result = """<router-link to="#{url}">#{result}</router-link>"""
            else 
                target = if element.linkTo.target then """target="#{element.linkTo.target}" rel="noopener"'""" else ''
                result = """<a href="#{url}" #{target}>#{result}</a>"""
            
        
        wrapperClassList = [element.label or '', 'block-img']
        result = """<p class="#{wrapperClassList.join(" ")}">#{result}</p>"""
        return result
    

    # Return null to stick with the default behavior for everything else
    return null

